import i18n from '@/lang';
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.object.to-string.js";
export default [{
  path: '/repairApply',
  name: 'RepairApply',
  component: function component() {
    return import('@/pages/repairManagement/repairApply');
  },
  meta: {
    name: i18n.tc("115")
  }
}, {
  path: '/repairRecord',
  name: 'RepairRecord',
  component: function component() {
    return import('@/pages/repairManagement/record');
  },
  meta: {
    name: i18n.tc("116")
  }
}, {
  path: '/repairRecordDetail',
  name: 'RepairRecordDetail',
  props: function props(route) {
    return {
      orderId: route.query.orderId
    };
  },
  component: function component() {
    return import('@/pages/repairManagement/record/detail');
  },
  meta: {
    name: i18n.tc("117")
  }
}, {
  path: '/signIn',
  name: 'SignIn',
  component: function component() {
    return import('@/pages/repairManagement/record/signIn');
  },
  meta: {
    name: i18n.tc("118")
  }
}];